module.exports = __webpack_public_path__ + "media/goforajourney/img/goforajourney-logo-white-h-2e91f93ae9d0de885daf262ce0af6283.png";